import { convertAttributesToBoolean, mapKeysToCamelCase } from '@skytech/utils'

import { API_ROUTE_ADMIN_COST_OBJECTS } from '@/resources/api-routes'
import assetLocationResources from '@/resources/asset-locations'
import { get } from '@/util/auth'

import type { CostObjectOriginal } from './cost-objects/types'

export async function getEmployees(hasLocationsAccess: boolean) {
  const costObjects = await get<CostObjectOriginal[]>(API_ROUTE_ADMIN_COST_OBJECTS)
  const camelCaseCostObjects = mapKeysToCamelCase(costObjects)
  const parsedCostObjects = camelCaseCostObjects.map(costObject =>
    convertAttributesToBoolean(costObject, 'isHidden')
  )

  const locations = hasLocationsAccess ? await assetLocationResources.getList() : []

  const employees: {
    id: number
    name: string
    customerId: number
    isLocation: boolean
    code: string
    isHidden?: boolean
    customerAddressId?: number
  }[] = [
    ...parsedCostObjects.map(co => ({
      id: co.id,
      name: co.name || '',
      isHidden: co.isHidden,
      isLocation: false,
      customerId: co.customerId,
      code: co.code,
    })),
    ...locations.map(location => ({
      id: location.id,
      name: location.name || '',
      isLocation: true,
      customerId: location.customer.id,
      customerAddressId: location.customerAddress?.id,
      code: location.code,
    })),
  ]

  return employees
}
